import React from 'react';

const Stage4 = (props) => {
    return (
        <div>Stage 4</div>
    );
}

export default Stage4;